import { GET_INDUSTRY_LIST_API } from '../constants/AppConstants';

/**
 * Service to get the industry Type list from the API, right now it is pointing to json file in public folder but should be replaced with
 * actual API endpoints once BE API is deployed and available to consume
 */
const getIndustries = async (featureFlagEnableGovtIndustry) => {
  try {
    const response = await fetch(GET_INDUSTRY_LIST_API, {
      method: 'GET',
    });

    let json = [];
    if (response.status !== 204) {
      json = await response.json();
    }

    if (!featureFlagEnableGovtIndustry) {
      json = json.filter((industry) => industry.name.toUpperCase() !== 'GOVERNMENT');
    }

    return { ok: response.ok, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: error.message } };
  }
};

export default getIndustries;
